import InboomaBaseModel from './InboomaBaseModel';

export default InboomaBaseModel.extend({

    urlRoot : '/wallet_transactions', // Though unused as read only...

    defaults : {
      id : "",
      reference : "",
      created : "",
      modified : "",
      deleted : "",
      wallet_id: "",
      order_id: "",
      order_nbr: "",
      parent_id: "",
      payment_date: "",
      debit: "",
      credit: "",
      currency: "",
      payment_status: "",
      payment_type: "",
      reference: "",
      accumulated_invoice_id: ""
    },
    
    _rbac : {
      "admin" : {
        "read" : true,
        "write" : true,
        "edit" : true,
        "remove" : true
      },
      "user" : {
        "read" : true,
        "write" : false,
        "edit" : false,
        "remove" : false
      },
      "manager" : {
        "read" : true,
        "write" : true,
        "edit" : false,
        "remove" : false
      },
      "booking-manager" : {
        "read" : true,
        "write" : true,
        "edit" : false,
        "remove" : false
      },
      "manager-location" : {
        "read" : true,
        "write" : true,
        "edit" : false,
        "remove" : false
      },
      "mediator" : {
        "read" : true,
        "write" : false,
        "edit" : false,
        "remove" : false
      },
      "garage-staff" : {
        "read" : true,
        "write" : false,
        "edit" : false,
        "remove" : false
      },
      "guide" : {
        "read" : false,
        "write" : false,
        "edit" : false,
        "remove" : false
      }
    }

});
